import * as React from 'react';
import { connect } from 'react-redux';

import { User } from '../../interface/user.interface';
import * as Action from '../../actions/authentication.actions';
import { ITenantBrief } from '../../interface/tenant.interface';

import { Project } from '@nexxt/common/types';
import http from '../../utils/http';
import { any } from 'prop-types';
import Loader from '../common/Loader/Loader';

interface ITemporaryComponentProps {
    toastNotification: any; //Example for interface
    setTenant: (tenant: ITenantBrief) => void;
    user: User;
}

interface ITemporaryComponentState {
    projects: Project[];
    loading: boolean;
}

class TemporaryComponent extends React.Component<
    ITemporaryComponentProps,
    ITemporaryComponentState
> {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            loading: false
        };
    }

    async destroy(projectId, index) {
        if (confirm('Are you sure?')) {
            try {
                const response = await http.get(
                    `/api/projects/${projectId}/destroy`
                );
                this.state.projects.splice(index, 1);
                this.setState({ projects: this.state.projects });
                alert('Deleted successfully');
            } catch (err) {
                console.log(err, '$$$$');
                alert('error');
            }
        }
    }

    async componentDidMount() {
        const url = `api/projects/all`;
        const response = await http.get(url);
        this.setState({ projects: response.data.data });
    }

    render() {
        return (
            <div className="card-container">
                <table className="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Project</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {this.state.projects.map((project, index) => {
                        return (
                            <tbody key={index}>
                                <tr>
                                    <td>{project.id}</td>
                                    <td>{project.name}</td>
                                    <td>{project.lastModifiedOn}</td>
                                    <td>
                                        <button
                                            className="btn btn-xs btn-danger"
                                            onClick={() =>
                                                this.destroy(project.id, index)
                                            }
                                        >
                                            Destroy
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </table>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    const {
        authReducer: { user } // Example to use value from reducer like this
    } = store;
    return {
        user
    };
};

const mapDispatchToProps = (dispatch) => ({
    setTenant: (tenant) => {
        // Example to map dispatch to props
        dispatch(Action.setTenant(tenant));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TemporaryComponent);
